import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {
  isCustomerAllowedForSelfCreatedTechnicianVisit,
  setIsSubmit,
  setNewTechnicianArrivalTime,
  setSelfCreatedTechnicianVisit,
  setError,
  setIsLoading,
  goToPage,
  clearState,
} from './SelfCreatedTechnicianVisitSlice';
import {getRecaptchaToken} from '../../../utilities/recaptcha/recaptcha';
import TechnicianArrivalTime from '../SaleBlock/TechnicianArrivalTime/TechnicianArrivalTime';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import FailureScreen from '../../Shared/FailureScreen/FailureScreen';
import EpiContext from '@episerver/spa-core/Spa';
import CheckedAnimation from '../../../animations/approved-checked-outline.json';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import Lottie from 'react-lottie';
import Config from '../../../Config';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import ThemedLottie from '../../Shared/ThemedLottie/ThemedLottie';
import { ThemeColorEnum } from '../../../utilities/theme/ThemeColorEnum';

const selfCreatedTechnicianVisit = (props) => {
  useEffect(() => {
    props.clearState();
    props.hideAppLoader();
    chechCustomerAllowedForSelfCreatedTechnicianVisit();
  }, []);

  useEffect(() => {
    if (props.isLoading == false) {
      props.setIsLoading(false);
      props.hideAppLoader();
    }
  }, [props.isLoading]);

  async function chechCustomerAllowedForSelfCreatedTechnicianVisit() {
    const token = await getRecaptchaToken('selfCreatedSlot');
    if (token != undefined && token != null) {
      props.isCustomerAllowedForSelfCreatedTechnicianVisit();
    }
  }

  let handleOnError = (errorId) => {
    props.setError({isDisplay: true, id: errorId});
  };

  let handleTechnicianValidate = (valid) => {
    props.goToPage('slotUpdated');
    props.setIsSubmit({isSubmit: false});
    if (valid) {
      handleTechnicianContinueAfterValid();
    }
    props.setIsSubmit({isSubmit: false});
  };

  let handleTechnicianContinueAfterValid = () => {
    if (props.technicianArrivalTime) {
      const newArrivalData = {
        IdNumber: props.userDetails.IDNumber,
        CityCode: props.customerAddress.cityCode,
        StreetName: props.customerAddress.streetName,
        StreetCode: props.customerAddress.streetCode,
        StartTime: props.technicianArrivalTime.arrivalStartDate,
        EndTime: props.technicianArrivalTime.arrivalEndDate,
        Date: props.technicianArrivalTime.arrivalTime,
        MatFlatNum: props.technicianArrivalTime.floor,
        TashtitType: props.customerAddress.infrastructure.tashtitType,
      };
      props.setIsLoading(true);
      props.showAppLoader();
      props.setSelfCreatedTechnicianVisit(newArrivalData);
    }
  };

  let updateSuccess = () => {
    return (
      <div className='success'>
        <p className='success-title'>{props.iContent.successTitle.value}</p>
        <p className='success-sub-title'>{props.iContent.successSubTitle.value}</p>
        <p className='success-free-text'>{props.iContent.successFreeText.value}</p>
        {/* <Lottie options={{animationData: CheckedAnimation, loop: false}} width={200} height={200} /> */}
        <ThemedLottie animationData={CheckedAnimation} color={ThemeColorEnum.PRIMARY} width={200} height={200} loop={false} />
        <BtnSubmit
          isBusiness={false}
          text={props.iContent.btnSuccessText.value}
          onclick={() => EpiContext.navigateTo(props.iContent.btnSuccessLink.value)}
          isDisplayArrows={props.isDisplayArrows}
        />
      </div>
    );
  };

  let technicianSlotsComponent = () => {
    return (
      <div className='tech-holder'>
        <p className='title'>מתי נוח לכם שנגיע?</p>
        <TechnicianArrivalTime
          onError={handleOnError}
          selectedAddress={props.customerAddress}
          onValid={handleTechnicianValidate}
          onSubmit={props.isSubmit}
          isBezeqFiber={props.customerAddress.infrastructure.tashtitType == 'BF' && props.customerAddress.infrastructure.tashtitType}
        />
        <div className='btn-holder'>
          <BtnSubmit
            isBusiness={false}
            text='המשך'
            onclick={() => props.setIsSubmit({isSubmit: true})}
            isDisplayArrows={props.isDisplayArrows}
          />
        </div>
      </div>
    );
  };

  let setCurrentView = () => {
    if (props.customerAddress.isDateExpired) {
      return <FailureScreen errorId={63} onclick={() => EpiContext.navigateTo(Config.lobbyUrl)} />;
    }
    if (props.customerAddress.isActiveVisitExist) {
      return <FailureScreen errorId={65} onclick={() => EpiContext.navigateTo(Config.lobbyUrl)} />;
    } else {
      return technicianSlotsComponent();
    }
  };

  return (
    <div className='selfCreatedTechnicianVisit'>
      {props.isShowTechnicianComponent ? setCurrentView() : null}
      {props.error.isDisplay ? <FailureScreen errorId={props.error.id} onclick={() => EpiContext.navigateTo(Config.lobbyUrl)} /> : null}
      {props.isSlotUpdatedSuccessfully ? updateSuccess() : null}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isShowTechnicianComponent: state.SelfCreatedTechnicianVisitSlice.isShowTechnicianComponent,
    customerAddress: state.SelfCreatedTechnicianVisitSlice.customerAddress,
    error: state.SelfCreatedTechnicianVisitSlice.error,
    isSubmit: state.SelfCreatedTechnicianVisitSlice.isSubmit,
    technicianArrivalTime: state.technicianArrivalTime.form,
    isGeneralError: state.SelfCreatedTechnicianVisitSlice.isGeneralError,
    userDetails: state.authentication.loginData.userDetails,
    isSlotUpdatedSuccessfully: state.SelfCreatedTechnicianVisitSlice.isSlotUpdatedSuccessfully,
    isLoading: state.SelfCreatedTechnicianVisitSlice.isLoading,
  };
};

const mapDispatchToProps = {
  isCustomerAllowedForSelfCreatedTechnicianVisit,
  setIsSubmit,
  setNewTechnicianArrivalTime,
  setSelfCreatedTechnicianVisit,
  showAppLoader,
  hideAppLoader,
  setError,
  setIsLoading,
  goToPage,
  clearState,
};

export default connect(mapStateToProps, mapDispatchToProps)(selfCreatedTechnicianVisit);
